import { useQuery } from '@apollo/client';
import {
  DirectionalHint,
  makeStyles,
  Stack,
  Text,
  TooltipHost,
} from '@fluentui/react';
import { Handle, Position } from '@xyflow/react';
import clsx from 'clsx';
import { useCommonStyles } from 'common/styles';
import React from 'react';
import { ApprovalSetupFlowCommonData } from 'settings/account/intuitiveApprovalSetupFlow/__generated__/ApprovalSetupFlowCommonData';
import { useStyles } from '../../../index.styles';
import { movingNodeId } from '../../ApproverLevels';
import { Body } from './body';
import { DeleteBranch } from './delete';
import { UpdateNode } from './update';
import APPROVAL_TYPE_DATA from '../../../../ApprovalSetupFlowCommonData.graphql';

// @ts-ignore
export const ApprovalBranchNode: React.FC = ({ data, isConnectable }) => {
  const styles = useStyles();
  const commonStyles = useCommonStyles();
  const { data: approvalTypes } = useQuery<ApprovalSetupFlowCommonData>(
    APPROVAL_TYPE_DATA,
    {
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'network-only',
      nextFetchPolicy: 'cache-only',
    }
  );
  const movingNode = movingNodeId();
  const tooltipContent = () => {
    if (!data.id) return undefined;
    return (
      <Stack tokens={{ childrenGap: 16 }} style={{ padding: 5 }}>
        {data?._infoLines?.infoLine1 && (
          <Text variant="small">{data._infoLines.infoLine1}</Text>
        )}
        {data?._infoLines?.infoLine2 && (
          <Text variant="small">{data._infoLines.infoLine2}</Text>
        )}
        {data?._infoLines?.infoLine3 && (
          <Text variant="small">{data._infoLines.infoLine3}</Text>
        )}
        {data?._infoLines?.infoLine4 && (
          <Text variant="small">{data._infoLines.infoLine4}</Text>
        )}
      </Stack>
    );
  };

  return (
    <Stack style={{ opacity: movingNode && movingNode !== data.id ? 0.5 : 1 }}>
      <Handle
        type="target"
        id={'approval-branch-top-edge'}
        position={Position.Top}
        isConnectable={isConnectable}
      />
      <TooltipHost
        content={tooltipContent()}
        directionalHint={DirectionalHint.bottomCenter}
      >
        <Stack className={styles.levelBranchesNodeContainer}>
          <Stack
            horizontalAlign="space-between"
            horizontal
            className={styles.approvalBranchNodeHeader}
          >
            <Stack className={styles.approvalNodeTitle} verticalAlign="center">
              <Text
                className={clsx(
                  commonStyles.colorThemePrimary,
                  commonStyles.bold
                )}
                style={{ verticalAlign: 'center' }}
              >
                {data.description}
              </Text>
            </Stack>

            <Stack
              horizontal
              verticalAlign="center"
              tokens={{ childrenGap: 20 }}
              style={{ height: 30 }}
            >
              <UpdateNode data={data} approvalTypes={approvalTypes} />
              <DeleteBranch data={data} />
            </Stack>
          </Stack>
          <Body data={data} />
        </Stack>
      </TooltipHost>

      <Handle
        type="source"
        id={'edge-source'}
        position={Position.Bottom}
        isConnectable={isConnectable}
      />
    </Stack>
  );
};

export const useConditionInfoStyles = makeStyles((theme) => ({
  calloutContainer: {
    backgroundColor: theme.palette.neutralLighterAlt,
  },
  updateConditionCalloutContainer: {
    // minWidth: 550,
    // width: 400,
    // maxHeight: 500,
    overflow: 'hidden',
    backgroundColor: theme.palette.neutralLighterAlt,
  },
}));
